import { Button } from "@blueprintjs/core";
import Login from "components/Login";
import SignUp from "components/SignUp";
import { useState } from "react";
import { Link } from "react-router-dom";
import { constructPath, findRoute, RootProps } from "routes";
import Navigation from "./Navigation";
import MobileOverlay from "./MobileOverlay";

export default function BeforeLogin(props: RootProps) {
  const { routes } = props;

  // Login Form state and handler
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const showLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);

  // Signup Form state and handler
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const showSignUp = () => setIsSignUpOpen(true);
  const closeSignUp = () => setIsSignUpOpen(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <div className="header before">
      <div className="header-left">
        <Link className="eset-logo" to={constructPath(findRoute(routes, "InfoHome"))}>
          <img className="logo--regular" src="images/ESET_Logo.svg" alt="Regular ESET Logo" />
          <img src="images/ESET_Mark.svg" alt="ESET" />
        </Link>
        <Navigation {...props} showChildren />
      </div>
      <div className="header-right">
        <Button key="login" icon="log-in" minimal intent="primary" text="Log In" onClick={showLogin} />
        <Button className="header-right--wb" key="signup" intent="primary" icon="new-person" text="Create Account" onClick={showSignUp} />
      </div>

      <Button
        className="mobile-menu-button"
        icon={isMobileMenuOpen ? "cross" : "menu"}
        minimal
        intent="primary"
        onClick={toggleMobileMenu}
      />

      <MobileOverlay
        {...props}
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        onLoginClick={showLogin}
        onSignUpClick={showSignUp}
      />

      <Login isOpen={isLoginOpen} onClose={closeLogin} />
      <SignUp isOpen={isSignUpOpen} onClose={closeSignUp} />
    </div>
  );
}
